import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faClock, faSpinner } from "@fortawesome/free-solid-svg-icons"

class InvitedList extends React.Component{
    render(){
        const { isLoading, invitedFriends } = this.props.state
        return(
            <div className="invitedList">
                <h3>You already invited:</h3>
                {isLoading === true 
                ? 
                <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div> 
                :
                invitedFriends.length === 0
                    ? <h5 className="noInvite">You haven't invited anyone. Introduce your friends to the platform!</h5>
                    : <>
                    <div className="invitedFriend">
                        <h5 className="col">Name</h5>
                        <h5 className="col">Email</h5>
                        <h5 className="col">Status</h5>
                    </div>
                    {invitedFriends.map(friend =>
                        <div className="invitedFriend" key={friend.id}>
                            <h5 className="col invited">{friend.name}</h5>
                            <h5 className="col invited">{friend.email}</h5>
                            <h5 className={`col invited ${friend.approved ? "approved" : "pending"}`}>
                                {friend.approved
                                ? <><FontAwesomeIcon icon={faCheckCircle} /> Approved!</>
                                : <><FontAwesomeIcon icon={faClock} /> Pending Approval</>
                                }
                            </h5>
                        </div>
                    )}
                    </>
                }
            </div>
        )
    }
}

export default InvitedList